import React from "react";
import Popup from "./Popup";
import classnames from "class-names";

const citiesList = [

  {
    letter: "Б",
    list: [ { name: "Борисоглебск", abbr: "bsk" } ],
  },
  {
    letter: "В",
    list: [ { name: "Воронеж", abbr: "vrn" } ],
  },
  {
    letter: "К",
    list: [
      { name: "Калининград", abbr: "klg" },
      { name: "Курск", abbr: "kur" },
    ]
  },
  {
    letter: "Н",
    list: [ { name: "Новосибирск", abbr: "nsk" } ]
  },
  {
    letter: "П",
    list: [ { name: "Пермь", abbr: "perm" } ]
  },
  {
    letter: "Р",
    list: [ { name: "Ростов-на-Дону", abbr: "rnd" } ]
  },
  {
    letter: "С",
    list: [ { name: "Смоленск", abbr: "smo" } ],
    // className: "popup-city-select__cities-group_indent-b_none"
  },
  { letter: "Т",
    list: [
      { name: "Тверь", abbr: "tver" },
      { name: "Тула", abbr: "tul" },
    ]
  },
  {
    letter: "Х",
    list: [ { name: "Хабаровск", abbr: "khb" } ]
  },
  {
    letter: "Ш",
    list: [ { name: "Шахты", abbr: "sht" } ]
  }
];

export const CitySelectPopupContent = () => (
  <div>
    {/* <div className="popup-city-select__search">
      <input placeholder="Введите город" />
    </div> */}

    <div className="popup-city-select__cities">
      {citiesList.map(el => {
        return (
          <div
            className={classnames(
              "popup-city-select__cities-group",
              el.className
            )}
            key={el.letter}
          >
            <div
              key={el.letter}
              className="popup-city-select__cities-group-header"
            >
              {el.letter}
            </div>
            {el.list.map(city => (
              <a key={city["abbr"]} href={`https://${city["abbr"]}.klinikaexpert.ru`} className="popup-city-select__city">
                {city["name"]}
              </a>
            ))}
          </div>
        );
      })}
    </div>
  </div>
);

const CitySelectPopup = ({ name }) => {
  return (
    <Popup className="popup-city-select" name={name} header="Выберите город">
      <CitySelectPopupContent />
    </Popup>
  );
};

export default CitySelectPopup;
